import React from 'react';
import { motion } from 'framer-motion';
import AthleteCard from './AthleteCard';
import { Skeleton } from '../ui/skeleton';

export default function AthleteGrid({ athletes, isLoading }) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 p-8">
        {Array(10).fill(0).map((_, i) => (
          <div key={i} className="flex flex-col items-center">
            <Skeleton className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-[#1a365d]" />
            <Skeleton className="w-24 h-4 mt-4 bg-[#1a365d]" />
            <Skeleton className="w-16 h-3 mt-2 bg-[#1a365d]" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 p-4 md:p-8"
    >
      {athletes.map((athlete, index) => (
        <AthleteCard key={athlete.id} athlete={athlete} index={index} />
      ))}
    </motion.div>
  );
}